import React from 'react';
import { AnnouncerContainer } from './elements';
export const Announcer = ({
  query,
  resultCount,
  selectedResultIndex,
  selectedResult,
  resultsAnnouncement = (query, resultCount) => `${resultCount} results found for '${query}'.`,
  noResultsAnnouncement = query => `No results found for '${query}'.`,
  resultSelectedAnnouncement = (resultName, resultCount, selectedResultIndex) => `${resultName}, result ${selectedResultIndex + 1} of ${resultCount} selected`
}) => {
  const hasQuery = query.length > 0;
  const hasResults = resultCount > 0;
  const hasSelectedResult = selectedResultIndex > -1;
  let content;
  if (!hasQuery) {
    content = null;
  } else if (!hasResults) {
    content = noResultsAnnouncement(query);
  } else if (hasResults) {
    content = resultsAnnouncement(query, resultCount);
    if (hasSelectedResult && selectedResult && selectedResult.header) {
      content += ' - ' + resultSelectedAnnouncement(selectedResult.header, resultCount, selectedResultIndex);
    }
  }
  return /*#__PURE__*/React.createElement(AnnouncerContainer, {
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, content);
};